import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { logOutAsyncThunk } from "../../store/slice/userSlice";
import { ReactComponent as CardIcon } from "../../inlineSvgs/card.svg";
import { ReactComponent as InfoIcon } from "../../inlineSvgs/info-circle.svg";
import { ReactComponent as ReceiptIcon } from "../../inlineSvgs/receipt-text.svg";
import { ReactComponent as ArrowIcon } from "../../inlineSvgs/arrow-right-2.svg";
import { ReactComponent as CopyIcon } from "../../inlineSvgs/copy.svg";
import { ReactComponent as PhoneIcon } from "../../inlineSvgs/phone-sup.svg";
import { ReactComponent as OutIcon } from "../../inlineSvgs/logout.svg";

const ProfileSettings = () => {
  const dispatch = useDispatch();
  const { screen } = useSelector((state) => state.userReducer);

  return (
    <div className="profile-settings">
      <div className="settings-list">
        <Link to="/privacy-policy" className="settings-list__item setting">
          <div className="left">
            <div className="setting__icon">
              <ReceiptIcon />
            </div>
            <div className="setting__title">Privacy Policy</div>
          </div>
          <div className="setting__arrow">
            <ArrowIcon />
          </div>
        </Link>

        <Link to="/terms-of-use" className="settings-list__item setting">
          <div className="left">
            <div className="setting__icon">
              <InfoIcon />
            </div>
            <div className="setting__title">Terms of use</div>
          </div>
          <div className="setting__arrow">
            <ArrowIcon />
          </div>
        </Link>

        <Link className="settings-list__item setting">
          <div className="left">
            <div className="setting__icon">
              <CardIcon />
            </div>
            <div className="setting__title">Imprint</div>
          </div>
          <div className="setting__arrow">
            <ArrowIcon />
          </div>
        </Link>
        {screen.mobile && (
          <div className="settings-list__item setting logout" onClick={() => dispatch(logOutAsyncThunk())}>
            <div className="left">
              <div className="setting__icon">
                <OutIcon />
              </div>
              <div className="setting__title">Logout</div>
            </div>
            <div className="setting__arrow">
              <ArrowIcon />
            </div>
          </div>
        )}
      </div>
      <div className="contacts">
        <div className="title">Support Contact</div>
        <div className="sub-title">
          For any questions or feedback regarding this application, please contact the administrator at
        </div>
        <a className="sup-link" href="meilto:support@monlis.de">
          support@monlis.de <CopyIcon />
        </a>
        <a className="sup-link" href="tel:+49 1514 1619858">
          +49 1514 1619858 <PhoneIcon />
        </a>
      </div>
    </div>
  );
};

export default ProfileSettings;
